import { render } from "./maizhenyi.vue?vue&type=template&id=477390a6&scoped=true"
import script from "./maizhenyi.vue?vue&type=script&lang=js"
export * from "./maizhenyi.vue?vue&type=script&lang=js"

import "./maizhenyi.vue?vue&type=style&index=0&id=477390a6&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477390a6"]])

export default __exports__